import { ReservationRow } from "../pages/reservations";
import { v4 as uuidv4 } from "uuid";

export function getPlatformName(platform: number): string {
    switch (platform) {
        case 1:
            return "Airbnb";
        case 2:
            return "Booking";
        default:
            return "Out";
    }
}

export function generateRandomReservationRows(count: number): ReservationRow[] {
    const apartments = ["Apt A", "Apt B", "Apt C", "Apt D", "Apt E"];
    const platforms = ["Airbnb", "Booking.com", "VRBO", "Expedia", "Direct"];

    const generateRandomDate = (start: Date, end: Date) => {
        return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    };

    const rows: ReservationRow[] = [];

    for (let i = 0; i < count; i++) {
        const bookingDate = generateRandomDate(new Date(2023, 0, 1), new Date());
        const startDate = generateRandomDate(
            bookingDate,
            new Date(bookingDate.getFullYear() + 1, bookingDate.getMonth(), bookingDate.getDate()),
        );
        const endDate = generateRandomDate(startDate, new Date(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate()));

        const actualDaysOfStay = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
        const receivableIncome = Math.round(Math.random() * 1000) + 500;
        const netIncome = receivableIncome * 0.85;

        const row: ReservationRow = {
            id: i + 1,
            apartment: apartments[Math.round(Math.random() * apartments.length)],
            platform: platforms[Math.round(Math.random() * platforms.length)],
            reservationCode: uuidv4().substring(0, 8),
            strApartmentID: i + 1,
            guestId: uuidv4(),
            platformEnum: Math.round(Math.random() * 3),
            bookingDate,
            startDate,
            endDate,
            actualDaysOfStay,
            guestName: `Guest ${i + 1}`,
            numberOfGuests: Math.round(Math.random() * 5) + 1,
            receivableIncome,
            netIncome,
            grossAdr: receivableIncome / actualDaysOfStay,
            netAdr: netIncome / actualDaysOfStay,
            vat: receivableIncome * 0.1,
            sustainabilityFee: Math.round(Math.random() * 20) + 10,
            temporaryStayDuty: Math.round(Math.random() * 30) + 20,
            amountPaid: Math.random() > 0.2 ? receivableIncome : undefined,
            paymentDate: Math.random() > 0.2 ? generateRandomDate(bookingDate, startDate) : undefined,
            commission: receivableIncome * 0.15,
            cleaningFee: Math.round(Math.random() * 100) + 50,
            cleaningCost: Math.round(Math.random() * 80) + 40,
            hostingExpense: Math.round(Math.random() * 50) + 30,
            epsilon: Math.random() > 0.5,
            uploadedToShortTermRegistry: Math.random() > 0.3,
        };

        rows.push(row);
    }

    return rows;
}
